var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.403,
    height: 52.403,
    viewBox: "0 0 52.403 52.403",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    "data-name": "Group 79",
    transform: "translate(-95.981 -2565.981)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    transform: "translate(95.981 2565.981)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26.201,
    cy: 26.201,
    r: 26.201,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.201,
    cy: 26.201,
    r: 25.201,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_25",
    "data-name": "Line 25",
    y2: 24.822,
    transform: "matrix(0.719, 0.695, -0.695, 0.719, 130.821, 2584.23)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_26",
    "data-name": "Line 26",
    x2: 24.822,
    transform: "matrix(0.719, 0.695, -0.695, 0.719, 113.272, 2584.536)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close_icon.aced4868e0e289a59edf0fcf636112ca.svg";
export { ForwardRef as ReactComponent };